'use client';

import { c as _c } from "react/compiler-runtime";
import { UserCircle, Xmark } from '@byway/icons';
import { useAuth } from '@clerk/nextjs';
import clsx from 'clsx';
import { useTranslations } from 'next-intl';
import { useEffect, useRef, useState } from 'react';
import { Dialog, Modal, ModalOverlay } from 'react-aria-components';
import { InlineAuth } from '~/components/Auth/InlineAuth';
import { Button } from '~/components/Button';
import { Drawer } from '~/components/Drawer';
import useBreakpoint from '~/hooks/useBreakpoint';
import { useAuthPromptStore } from '~/stores/authPromptStore';
import styles from './AuthPopover.module.css';
export const AuthPopover = () => {
  const $ = _c(70);
  const t = useTranslations("account");
  const tAria = useTranslations("aria");
  const {
    isSignedIn
  } = useAuth();
  const {
    isMobile
  } = useBreakpoint();
  const [isMobileReady, setIsMobileReady] = useState(false);
  const {
    isOpen,
    reason,
    source,
    returnTo,
    open,
    close
  } = useAuthPromptStore();
  const triggerRef = useRef(null);
  const [dockGutter, setDockGutter] = useState();
  const isDocked = source === "nav";
  const showAuth = isOpen && !isSignedIn;
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      setIsMobileReady(true);
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  let t3;
  if ($[2] !== isDocked || $[3] !== showAuth) {
    t2 = () => {
      if (!showAuth || !isDocked) {
        return;
      }
      const rect = triggerRef.current?.getBoundingClientRect();
      if (rect) {
        setDockGutter(Math.max(0, globalThis.innerWidth - rect.right));
      }
    };
    t3 = [showAuth, isDocked];
    $[2] = isDocked;
    $[3] = showAuth;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  useEffect(t2, t3);
  let t4;
  let t5;
  if ($[6] !== close || $[7] !== isOpen || $[8] !== isSignedIn) {
    t4 = () => {
      if (isSignedIn && isOpen) {
        close();
      }
    };
    t5 = [isSignedIn, isOpen, close];
    $[6] = close;
    $[7] = isOpen;
    $[8] = isSignedIn;
    $[9] = t4;
    $[10] = t5;
  } else {
    t4 = $[9];
    t5 = $[10];
  }
  useEffect(t4, t5);
  let t6;
  if ($[11] !== close || $[12] !== open || $[13] !== reason || $[14] !== source) {
    t6 = function handleOpenChange(isNowOpen) {
      if (isNowOpen) {
        open(reason, source);
      } else {
        close();
      }
    };
    $[11] = close;
    $[12] = open;
    $[13] = reason;
    $[14] = source;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  const handleOpenChange = t6;
  let t7;
  if ($[16] !== reason || $[17] !== t) {
    t7 = reason ?? t("auth_title");
    $[16] = reason;
    $[17] = t;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  const title = t7;
  const t8 = returnTo ?? "/";
  let t9;
  if ($[19] !== reason || $[20] !== t8) {
    t9 = <InlineAuth redirectUrl={t8} message={reason} />;
    $[19] = reason;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  const authPanel = t9;
  let t10;
  if ($[22] !== t) {
    t10 = t("auth_log_in");
    $[22] = t;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== open) {
    t11 = () => open(undefined, "nav");
    $[24] = open;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <UserCircle decorative={true} size="scale" strokeWidth={1.2} />;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== showAuth || $[28] !== t10 || $[29] !== t11) {
    t13 = <button ref={triggerRef} type="button" className={styles.trigger} aria-label={t10} aria-haspopup="dialog" aria-expanded={showAuth} onClick={t11}>{t12}</button>;
    $[27] = showAuth;
    $[28] = t10;
    $[29] = t11;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  const trigger = t13;
  if (isMobileReady && isMobile) {
    let t14;
    if ($[31] !== handleOpenChange) {
      t14 = () => handleOpenChange(false);
      $[31] = handleOpenChange;
      $[32] = t14;
    } else {
      t14 = $[32];
    }
    let t15;
    if ($[33] !== authPanel || $[34] !== showAuth || $[35] !== t14 || $[36] !== title) {
      t15 = <Drawer ariaLabel={title} isOpen={showAuth} close={t14} noHeader={true}>{authPanel}</Drawer>;
      $[33] = authPanel;
      $[34] = showAuth;
      $[35] = t14;
      $[36] = title;
      $[37] = t15;
    } else {
      t15 = $[37];
    }
    let t16;
    if ($[38] !== t15 || $[39] !== trigger) {
      t16 = <>{trigger}{t15}</>;
      $[38] = t15;
      $[39] = trigger;
      $[40] = t16;
    } else {
      t16 = $[40];
    }
    return t16;
  }
  const t14 = !isDocked && styles.overlayCentred;
  let t15;
  if ($[41] !== t14) {
    t15 = clsx(styles.overlay, t14);
    $[41] = t14;
    $[42] = t15;
  } else {
    t15 = $[42];
  }
  const t16 = isDocked ? styles.panelDocked : styles.panelCentred;
  let t17;
  if ($[43] !== t16) {
    t17 = clsx(styles.panel, t16);
    $[43] = t16;
    $[44] = t17;
  } else {
    t17 = $[44];
  }
  let t18;
  if ($[45] !== dockGutter || $[46] !== isDocked) {
    t18 = isDocked && dockGutter !== undefined ? {
      right: dockGutter
    } : undefined;
    $[45] = dockGutter;
    $[46] = isDocked;
    $[47] = t18;
  } else {
    t18 = $[47];
  }
  let t19;
  if ($[48] !== tAria) {
    t19 = tAria("close");
    $[48] = tAria;
    $[49] = t19;
  } else {
    t19 = $[49];
  }
  let t20;
  if ($[50] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <Xmark decorative={true} size="large" />;
    $[50] = t20;
  } else {
    t20 = $[50];
  }
  let t21;
  if ($[51] !== close || $[52] !== t19) {
    t21 = <div className={styles.close}><Button variant="icon" ariaLabel={t19} onPress={close}>{t20}</Button></div>;
    $[51] = close;
    $[52] = t19;
    $[53] = t21;
  } else {
    t21 = $[53];
  }
  let t22;
  if ($[54] !== authPanel || $[55] !== t21 || $[56] !== title) {
    t22 = <Dialog aria-label={title} className={styles.dialog}>{t21}{authPanel}</Dialog>;
    $[54] = authPanel;
    $[55] = t21;
    $[56] = title;
    $[57] = t22;
  } else {
    t22 = $[57];
  }
  let t23;
  if ($[58] !== t17 || $[59] !== t18 || $[60] !== t22) {
    t23 = <Modal className={t17} style={t18}>{t22}</Modal>;
    $[58] = t17;
    $[59] = t18;
    $[60] = t22;
    $[61] = t23;
  } else {
    t23 = $[61];
  }
  let t24;
  if ($[62] !== handleOpenChange || $[63] !== showAuth || $[64] !== t15 || $[65] !== t23) {
    t24 = <ModalOverlay className={t15} isDismissable={true} isOpen={showAuth} onOpenChange={handleOpenChange}>{t23}</ModalOverlay>;
    $[62] = handleOpenChange;
    $[63] = showAuth;
    $[64] = t15;
    $[65] = t23;
    $[66] = t24;
  } else {
    t24 = $[66];
  }
  let t25;
  if ($[67] !== t24 || $[68] !== trigger) {
    t25 = <>{trigger}{t24}</>;
    $[67] = t24;
    $[68] = trigger;
    $[69] = t25;
  } else {
    t25 = $[69];
  }
  return t25;
};